import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import OutsideClickHandler from 'react-outside-click-handler'
import { mdiChevronRight } from '@mdi/js'

import theme from 'theme_'
import BackButton from 'components/AsideMenu/BackButton'
import {
  MenuCollapseButton,
  MenuCollapseIcon,
  StyledHomeAside,
  StyledAsideMenu,
  StyledAsideMenuCollapseItem,
  StyledAsideMenuIcon,
  StyledAsideMenuItem,
  StyledAsideMenuLink,
  StyledAsideMenuLinkTitle,
} from 'components/AsideMenu/styles'
import { ASIDE_CONST } from 'features/aside/consts'

interface AsideMenuItem {
  icon: string
  title: string
  to: string
}

interface AsideMenuProps {
  menu: AsideMenuItem[]
  openAside: () => void
  closeAside: () => void
}

function AsideMenu({ menu, openAside, closeAside }: AsideMenuProps) {
  const { pathname } = useLocation()
  const isMediumDesktop = useMediaQuery({ query: theme.devices.mediumDesktop })
  const isTablet = useMediaQuery({ query: theme.devices.tablet })
  const shouldUseCollapse = isTablet && !isMediumDesktop

  const [collapse, setCollapse] = useState<boolean>(shouldUseCollapse)

  useEffect(() => {
    openAside()
    return () => {
      closeAside()
    }
  }, [openAside, closeAside])

  useEffect(() => {
    setCollapse(shouldUseCollapse)
  }, [shouldUseCollapse])

  const handleCollapse = () => {
    setCollapse(!collapse)
  }

  const handleCollapseOnClick = () => {
    if (shouldUseCollapse) {
      setCollapse(true)
    }
  }

  return (
    <StyledHomeAside id={ASIDE_CONST} $isCollapsed={collapse}>
      <BackButton />

      <OutsideClickHandler onOutsideClick={handleCollapseOnClick}>
        <nav>
          <StyledAsideMenu>
            {shouldUseCollapse && (
              <StyledAsideMenuCollapseItem>
                <MenuCollapseButton onClick={handleCollapse}>
                  <MenuCollapseIcon
                    path={mdiChevronRight}
                    size={1}
                    rotate={collapse ? 0 : 180}
                  />
                </MenuCollapseButton>
              </StyledAsideMenuCollapseItem>
            )}

            {menu.map(({ icon, title, to }) => (
              <StyledAsideMenuItem key={to} selected={pathname.includes(to)}>
                <StyledAsideMenuLink
                  to={to}
                  title={title}
                  onClick={handleCollapseOnClick}
                >
                  <StyledAsideMenuIcon path={icon} size={1} />
                  {!collapse && (
                    <StyledAsideMenuLinkTitle>{title}</StyledAsideMenuLinkTitle>
                  )}
                </StyledAsideMenuLink>
              </StyledAsideMenuItem>
            ))}
          </StyledAsideMenu>
        </nav>
      </OutsideClickHandler>
    </StyledHomeAside>
  )
}

export default AsideMenu
